import {Helmet} from './helmet';
import {useBootstrapData} from '../core/bootstrap-data/bootstrap-data-context';
import {useSettings} from '../core/settings/use-settings';

export function DefaultMetaTags() {
  const {
    data: {default_meta_tags},
  } = useBootstrapData();
  const {
    branding: {site_name},
  } = useSettings();
  return (
    <Helmet tags={default_meta_tags}>
      <title>{site_name}</title>
    </Helmet>
  );
}
